export enum TipoLayout {
    LISTA = 1,
    GRADE = 2 
}


// WEBPACK FOOTER //
// ./src/shared/interfaces.ts